/* eslint-disable react/no-array-index-key */

import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl, { FormControlProps } from "@material-ui/core/FormControl";
import MUISelect, { SelectProps as MUISelectProps } from "@material-ui/core/Select";
import React, { FC } from "react";
import { Theme } from "@material-ui/core/styles";
import { styled } from "@material-ui/styles";

import { SelectOptionType } from "../../../elements/Select/Select";

type SelectRedesignProps = {
  options: SelectOptionType[];
};

const StyledFormControl = styled(FormControl)(({ theme }: { theme: Theme }) => ({
  "& .MuiInputBase-root": {
    height: 40,
    fontSize: 13,
    color: theme.palette.brand.gray900,
    background: theme.palette.brand.white,
    borderRadius: 8,
  },
  "& .MuiSelect-select": {
    padding: "10px 32px 10px 14px",
    minHeight: "unset",
    fontWeight: 500,
  },
  "& .MuiInputLabel-outlined": {
    fontSize: 12,
    fontWeight: 500,
    color: theme.palette.brand.gray500,
    transform: "translate(14px, 11px) scale(1)",
  },
  "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
    transform: "translate(14px, -6px) scale(0.85)",
    background: theme.palette.brand.white,
    padding: "0 4px",
  },
  "& label.Mui-focused": {
    color: theme.palette.brand.gray500,
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: 8,
    "& fieldset": {
      borderColor: theme.palette.brand.gray200,
    },
    "&:hover fieldset": {
      borderColor: theme.palette.brand.gray300,
    },
    "&.Mui-focused fieldset": {
      borderColor: theme.palette.brand.blueAccent,
      borderWidth: 1,
    },
  },
  "& .MuiSelect-icon": {
    color: theme.palette.brand.gray700,
    right: 10,
  },
}));

const StyledMenuItem = styled(MenuItem)(({ theme }: { theme: Theme }) => ({
  fontSize: 13,
  color: theme.palette.brand.gray900,
  "&:hover": {
    background: theme.palette.brand.gray50,
  },
  "&.Mui-selected": {
    background: theme.palette.brand.gray100,
    fontWeight: 600,
  },
}));

const SelectRedesign: FC<MUISelectProps & FormControlProps & SelectRedesignProps> = ({
  variant,
  className,
  label,
  value,
  onChange,
  name,
  options,
  fullWidth = true,
  ...rest
}) => {
  const hasValue = value !== undefined && value !== null && value !== "";

  return (
    <StyledFormControl variant={variant ?? "outlined"} className={className} fullWidth={fullWidth}>
      <InputLabel {...(hasValue ? { shrink: true } : {})}>{label}</InputLabel>
      <MUISelect
        value={value}
        onChange={onChange}
        name={name}
        label={label}
        MenuProps={{
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          getContentAnchorEl: null,
          PaperProps: {
            style: {
              borderRadius: 8,
              marginTop: 4,
            },
          },
        }}
        {...rest}
      >
        {!hasValue && label ? (
          <StyledMenuItem value="" disabled>
            {label}
          </StyledMenuItem>
        ) : null}
        {options.map((option: SelectOptionType, index: number) => (
          <StyledMenuItem key={option?.key ? option.key : `${option.label}-${index}`} value={option.value}>
            {option.label}
          </StyledMenuItem>
        ))}
      </MUISelect>
    </StyledFormControl>
  );
};

export default SelectRedesign;
